import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

//Hace que cuando clickeas en cualquier Link te redireccione a la parte de arriba de la página
function ScrollToTop({ history }) {
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  }, []);

  return null;
}

export default withRouter(ScrollToTop);
